<div class="wrap">
  <app-page-site-switcher></app-page-site-switcher>
  <ng-container *ngIf="queues().length; else empty">
    <div class="grid">
      <app-queue-card
        *ngFor="let q of queues(); trackBy: trackByIndex"
        [queue]="q">
      </app-queue-card>
    </div>
  </ng-container>

  <ng-template #empty>
    <div class="muted">{{ 'accueil.empty' | translate }}</div>
  </ng-template>
</div>
